import React from "react";

const getInitial = (name) => {
  if (typeof name !== "string") return "U";
  const trimmed = name.trim();
  if (!trimmed) return "U";
  return trimmed.charAt(0).toUpperCase();
};

const getAvatarBgClass = (name) => {
  const palette = [
    "bg-orange-100",
    "bg-orange-200",
    "bg-orange-100",
    "bg-orange-200",
    "bg-orange-100",
  ];

  const source = typeof name === "string" ? name : "";
  let hash = 0;
  for (let i = 0; i < source.length; i += 1) {
    hash = source.charCodeAt(i) + ((hash << 5) - hash);
  }

  const index = Math.abs(hash) % palette.length;
  return palette[index] || "bg-gray-500";
};

const UserAvatar = ({ name, profileImage, className = "w-10 h-10" }) => {
  const initial = getInitial(name);
  const hasImage =
    typeof profileImage === "string" && profileImage.trim() !== "";

  if (hasImage) {
    return (
      <img
        src={profileImage}
        alt={name || "User"}
        className={`${className} rounded-full object-cover`}
      />
    );
  }

  return (
    <div
      className={`${className} rounded-full flex items-center justify-center font-semibold text-sm text-[#C2410C] ${getAvatarBgClass(name)}`}
      aria-label={name || "User"}
    >
      {initial}
    </div>
  );
};

export default UserAvatar;
